export function getEmbedUrl(url) {
  if (!url) return null;
  try {
    const u = new URL(url);
    const host = u.hostname.replace("www.", "");
    if (host === "youtube.com" || host === "m.youtube.com") {
      const id = u.searchParams.get("v");
      if (id) return `https://www.youtube.com/embed/${id}`;
      if (u.pathname.startsWith("/embed/")) return url;
      if (u.pathname.startsWith("/shorts/")) return `https://www.youtube.com/embed/${u.pathname.split("/")[2]}`;
    }
    if (host === "youtu.be") return `https://www.youtube.com/embed/${u.pathname.slice(1)}`;
    if (host === "vimeo.com") return `https://player.vimeo.com/video/${u.pathname.split("/").filter(Boolean).pop()}`;
    if (host === "player.vimeo.com") return url;
    // Direct video file
    if (/\.(mp4|webm|ogg)(\?.*)?$/i.test(u.pathname)) return url;
  } catch {
    return null;
  }
  return url;
}

export function isDirectVideo(url) {
  return url && /\.(mp4|webm|ogg)(\?.*)?$/i.test(url);
}
